module.exports = __webpack_public_path__ + "img/INPRG.f177ad35.svg";